import type { ApiClient } from '../client'
import type {
  CreateTemplateRequest,
  EventTypesResponse,
  ListMessagesQuery,
  ListTemplatesQuery,
  MessageSummary,
  MessageTemplate,
  PreviewTemplateRequest,
} from '../types'

/**
 * src/modules/messaging/controllers/templates.controller.ts
 *
 * ★ There is no update and no delete: `create` writes the NEXT version, and `approve` is one-way
 *   (BE-25). The client offers exactly those two writes.
 */
export function templatesEndpoints(api: ApiClient) {
  return {
    list: (query: ListTemplatesQuery = {}) =>
      api.get<readonly MessageTemplate[]>('message-templates', { query: { ...query } }),
    eventTypes: () => api.get<EventTypesResponse>('message-templates/event-types'),
    get: (id: string) => api.get<MessageTemplate>(`message-templates/${id}`),
    create: (body: CreateTemplateRequest) => api.post<MessageTemplate>('message-templates', body),
    approve: (id: string) => api.post<MessageTemplate>(`message-templates/${id}/approve`),
    preview: (id: string, body: PreviewTemplateRequest) =>
      api.post<{ readonly body: string }>(`message-templates/${id}/preview`, body),
  }
}

/** src/modules/messaging/controllers/messages.controller.ts — reads only; sending is system-only. */
export function messagesEndpoints(api: ApiClient) {
  return {
    list: (query: ListMessagesQuery = {}) =>
      api.get<readonly MessageSummary[]>('messages', { query: { ...query } }),
  }
}
